module.exports = "<app-loader></app-loader>\n<router-outlet>\n    <app-spinner></app-spinner>\n</router-outlet>\n"